import StatusChip from './StatusChip';
import { StatusChipProps, StatusChipValueProps } from './types';

export type { StatusChipProps, StatusChipValueProps };
export default StatusChip;
